module.exports = __webpack_public_path__ + "img/shebei.40fa65f9.png";